import * as React from "react"

export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <path
      fill="currentColor"
      d="m35.084 48.32-8.455-8.487a2.03 2.03 0 0 0-1.4-.573q-.811-.017-1.453.625-.59.59-.59 1.4 0 .811.59 1.4l9.622 9.674q.717.75 1.686.75.968 0 1.686-.75l19.34-19.308q.608-.64.625-1.452.015-.81-.625-1.451-.642-.59-1.478-.565a2.04 2.04 0 0 0-1.426.616zm4.922 23.347q-6.518 0-12.283-2.494-5.765-2.493-10.082-6.809-4.318-4.315-6.813-10.078t-2.494-12.28q0-6.57 2.493-12.351 2.493-5.78 6.81-10.057 4.315-4.275 10.078-6.77 5.76-2.495 12.28-2.495 6.57 0 12.35 2.494 5.782 2.493 10.057 6.767t6.771 10.053q2.494 5.778 2.494 12.347 0 6.518-2.493 12.284-2.493 5.765-6.768 10.082-4.274 4.318-10.052 6.813t-12.347 2.494m-.005-3.783q11.64 0 19.762-8.147T67.885 40q0-11.64-8.122-19.762t-19.762-8.122q-11.59 0-19.738 8.122T12.116 40q0 11.59 8.147 19.737 8.148 8.148 19.738 8.147"
    ></path>
  </svg>
)
